
import { useState } from 'react';

export default function FormularioSection() {
  const [formData, setFormData] = useState({
    nome: '',
    whatsapp: '',
    tipoproblema: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.nome || !formData.whatsapp || !formData.tipoproblema) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nome', formData.nome);
      formBody.append('whatsapp', formData.whatsapp);
      formBody.append('tipoproblema', formData.tipoproblema);

      const response = await fetch('https://readdy.ai/api/form/d6aq62lbiueuoqm1slrg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nome: '', whatsapp: '', tipoproblema: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contato" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-teal-50 text-teal-700 text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full mb-4">
            Rápido e Gratuito
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-serif">
            Descubra se você tem direito
          </h2>
          <p className="text-base text-gray-600 max-w-xl mx-auto">
            Preencha apenas 3 campos. Analisamos seu caso gratuitamente e respondemos em até 24 horas pelo WhatsApp.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-10 md:p-14 border border-gray-100">
          <form id="analise-rapida-form" data-readdy-form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mb-7">
              <div>
                <label htmlFor="nome" className="block text-sm font-medium text-gray-900 mb-2">
                  Seu Nome <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  required
                  className="w-full bg-gray-50 border border-gray-200 rounded-lg px-5 py-4 text-sm text-gray-900 placeholder-gray-400 focus:bg-white focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500/20 transition-all"
                  placeholder="Digite seu nome completo"
                />
              </div>
              <div>
                <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-900 mb-2">
                  Seu WhatsApp <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleInputChange}
                  required
                  className="w-full bg-gray-50 border border-gray-200 rounded-lg px-5 py-4 text-sm text-gray-900 placeholder-gray-400 focus:bg-white focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500/20 transition-all"
                  placeholder="(00) 00000-0000"
                />
              </div>
            </div>

            <div className="mb-8">
              <label htmlFor="tipoproblema" className="block text-sm font-medium text-gray-900 mb-2">
                O Que Aconteceu Com Seu Voo? <span className="text-red-500">*</span>
              </label>
              <select
                id="tipoproblema"
                name="tipoproblema"
                value={formData.tipoproblema}
                onChange={handleInputChange}
                required
                className="w-full bg-gray-50 border border-gray-200 rounded-lg px-5 py-4 text-sm text-gray-900 focus:bg-white focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500/20 transition-all cursor-pointer"
              >
                <option value="">Selecione o problema que você teve</option>
                <option value="Atraso de voo">Atraso de voo (mais de 4 horas)</option>
                <option value="Cancelamento de voo">Cancelamento de voo</option>
                <option value="Overbooking">Overbooking (impedido de embarcar)</option>
                <option value="Perda de conexão">Perda de conexão</option>
                <option value="Extravio de bagagem">Extravio de bagagem</option>
                <option value="Dano à bagagem">Dano à bagagem</option>
                <option value="Outro">Outro problema</option>
              </select>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full inline-flex items-center justify-center gap-3 bg-teal-600 hover:bg-teal-700 text-white py-5 rounded-xl text-lg font-bold uppercase transition-all duration-300 hover:scale-[1.02] hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line text-xl animate-spin"></i>
                  Enviando...
                </>
              ) : (
                <>
                  <i className="ri-send-plane-line text-xl"></i>
                  Enviar Para Análise Gratuita
                </>
              )}
            </button>

            {submitStatus === 'success' && (
              <div className="mt-6 bg-green-50 border border-green-200 rounded-lg p-5 flex items-start gap-3">
                <i className="ri-checkbox-circle-line text-2xl text-green-600 mt-0.5"></i>
                <div>
                  <p className="text-green-800 font-bold">Recebemos suas informações!</p>
                  <p className="text-green-700 text-sm mt-1">
                    Nossa equipe vai analisar seu caso e entrar em contato pelo WhatsApp em até 24 horas. Fique atento às mensagens!
                  </p>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mt-6 bg-red-50 border border-red-200 rounded-lg p-5 flex items-start gap-3">
                <i className="ri-error-warning-line text-2xl text-red-600 mt-0.5"></i>
                <div>
                  <p className="text-red-800 font-bold">Ops! Algo deu errado</p>
                  <p className="text-red-700 text-sm mt-1">
                    Verifique se preencheu todos os campos corretamente e tente novamente.
                  </p>
                </div>
              </div>
            )}
          </form>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500">
            <span className="flex items-center gap-2">
              <i className="ri-shield-check-line text-teal-500"></i>
              100% gratuito
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-lock-line text-teal-500"></i>
              Dados protegidos
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-timer-line text-teal-500"></i>
              Resposta em 24h
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-hand-heart-line text-teal-500"></i>
              Sem compromisso
            </span>
          </div>
        </div>

        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm mb-3">Prefere falar diretamente pelo WhatsApp?</p>
          <a
            href="https://wa.me/5528998813826?text=Ol%C3%A1%2C%20tive%20um%20problema%20com%20meu%20voo%20e%20quero%20saber%20se%20tenho%20direito%20a%20indeniza%C3%A7%C3%A3o.%20Pode%20me%20ajudar%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full text-base font-bold transition-all duration-300 hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Chamar no WhatsApp Agora
          </a>
        </div>
      </div>
    </section>
  );
}
